/**
 * Converts HTML-ish API strings to plain text for safe display (no v-html).
 * Preserves line breaks from common block/line-break tags before stripping tags.
 * @param {unknown} value
 * @returns {string} Plain text with tags removed.
 */
export function stripHtmlToPlainText(value) {
  if (value == null)
    return '';
  let str = String(value);
  str = str.replace(/<br\s*\/?>/gi, '\n');
  str = str.replace(/<\/(p|div|li|h[1-6]|tr)\s*>/gi, '\n');
  str = str.replace(/<[^>]+>/g, '');
  return str.replace(/\n{3,}/g, '\n\n').trim();
}
